import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import { DateTimePicker } from '@mui/x-date-pickers';
import { getCompanies } from '../../../shared/api/api';
import typesPay from '../../../shared/constants/typesPay';
import DEFAULT_PAYMENTS_FILTERS from './constants';
import FiltersRow from './styles/FiltersRow';
import DateLabel from './styles/DateLabel';
import DateRangeWrapper from './styles/DateRangeWrapper';
import ActionsRow from './styles/ActionsRow';
import CreateLink from './styles/CreateLink';
import useAuth from '../../../shared/lib/hooks/useAuth';

function PaymentInfoTableFiltersWidget({ filters, setFilters, setPage }) {
  const { isDealer, companyAccount } = useAuth();
  const { companyId } = companyAccount?.company || {};

  const [localFilters, setLocalFilters] = useState({ ...filters });
  const [companies, setCompanies] = useState([]);

  const updateFilters = (key, value) => {
    setLocalFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSearch = () => {
    setFilters(localFilters);
    setPage(0);
  };

  useEffect(() => {
    if (!companyId) return;

    getCompanies(isDealer ? { dealerCompanyId: companyId } : {})
      .then((res) => {
        setCompanies([...res].sort((a, b) => a.name.localeCompare(b.name)));
      })
      .catch((error) => {
        throw error;
      });
  }, [companyId]);

  return (
    <Box>
      <FiltersRow>
        <Autocomplete
          fullWidth
          size="medium"
          autoComplete
          value={localFilters.company}
          onChange={(event, newValue) => {
            updateFilters('company', newValue);
          }}
          id="route"
          options={companies}
          getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
          renderInput={(params) => <TextField {...params} label="Компания" />}
          filterOptions={(options, state) =>
            options.filter((o) =>
              o.name ? o.name.toUpperCase().includes(state.inputValue.toUpperCase()) : o.name === state.inputValue,
            )
          }
          renderOption={(props, item) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <li {...props} key={item.companyId}>
              <ListItemText>{item.name}</ListItemText>
            </li>
          )}
        />

        <Box>
          <DateLabel variant="body1">Дата зачисления платежа</DateLabel>
          <DateRangeWrapper>
            <DateTimePicker
              label="с"
              value={localFilters.dateFrom && new Date(localFilters.dateFrom)}
              inputFormat="dd/MM/yyyy"
              onChange={(e) => {
                // eslint-disable-next-line no-restricted-globals
                if (!isNaN(e) && e) {
                  const adjustedDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000).toISOString();
                  updateFilters('dateFrom', adjustedDate);
                } else {
                  updateFilters('dateFrom', null);
                }
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
            -
            <DateTimePicker
              label="по"
              value={localFilters.dateTo && new Date(localFilters.dateTo)}
              inputFormat="dd/MM/yyyy"
              onChange={(e) => {
                // eslint-disable-next-line no-restricted-globals
                if (!isNaN(e) && e) {
                  const adjustedDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000).toISOString();
                  updateFilters('dateTo', adjustedDate);
                } else {
                  updateFilters('dateTo', null);
                }
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </DateRangeWrapper>
        </Box>

        <FormControl fullWidth>
          <InputLabel id="category-label">Тип операции</InputLabel>
          <Select
            labelId="category-label"
            id="category-label"
            value={localFilters.type || 0}
            label="Категория сообщений"
            onChange={(e) => {
              updateFilters('type', e.target.value);
            }}
          >
            {typesPay.map((typesPayCurrent, i) => (
              <MenuItem key={`alertsType-select-item${typesPayCurrent.id}-${i + 1}`} value={typesPayCurrent.id}>
                {typesPayCurrent.value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </FiltersRow>

      <ActionsRow>
        <Button disableElevation onClick={() => setLocalFilters(DEFAULT_PAYMENTS_FILTERS)} variant="text">
          Сбросить
        </Button>
        <Button onClick={handleSearch} variant="contained">
          Поиск
        </Button>
        <CreateLink to="create">
          <Button sx={{ width: '300px' }} variant="contained">
            Создать
          </Button>
        </CreateLink>
      </ActionsRow>
    </Box>
  );
}

PaymentInfoTableFiltersWidget.propTypes = {
  filters: PropTypes.shape().isRequired,
  setFilters: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
};

export default PaymentInfoTableFiltersWidget;
